import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CCol,
  CButton,
  CPagination
} from "@coreui/react";
import { connect } from "react-redux";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import DefaultDiscipline from "../../assets/imgs/disciplines/default.PNG";
import URL from "../../config/api";
import axios from "../../config/axios";
import { arrayToCSV, arrayToXLSX, arrayToXLS } from "../../utils/export";
import EmotionsContentItem from "../EmotionsContentItem";
import FilterWithDate from "../FilterWithDate/index";
import Loading from "../Loading";

import "../Content/css/content.css";
import "./style.css";

class EmotionsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selected: [],
      filters: {},
      modal: false,
      modalOrder: false,
      content: null,
      // activity: false,
      // selection: [],
      contentList: {
        type: null,
        list: []
      },
      segments: [],
      // disciplines: [],
      // objectives: [],
      // modules: [],
      // units: [],
      // series: [],
      filter: {
        word: null,
        segment: { value: null, label: "Todos" },
        discipline: { value: null, label: "Todos" },
        serie: { value: null, label: "Todas" },
        module: { value: null, label: "Todos" },
        ability: { value: null, label: "Todos" }
      },
      filterCollapse: false,
      type: this.props.type,
      ability_filter: true,
      maxItems: 24,
      currentPage: 1,
      modulesSegments: null,
      abilitiesSegments: null,
      // lastGroup: null,
      // lastRegion: null,
      // lastRole: null,
      // lastSchool: null,
      // lastRoom: null,
      // lastDate: null,
      infoSelected: {},
      showModal: false,
      currentContentOpened: null,
      from: null,
      to: null,
      fromHistory: null,
      // toHistory: null,
      currentMonth: null,
      currentUserId: null,
      loadingHistory: true
    };
  }

  takeContentSelected = (elem, contentId) => {
    if (elem.current) {
      const elemString =
        elem.current.getElementsByClassName("contentTitle")[0].innerText;
      this.props.addContent(elemString, contentId);
      this.props.hideModal(true);
    }
  };

  increaseOrDecreaseMonth(number) {
    let actualMonth = this.state.currentMonth.number;
    if (number > 0) {
      actualMonth += number;
      if (actualMonth + 1 === 13) {
        actualMonth = 12;
      }
    } else {
      actualMonth += number;
      if (actualMonth + 1 === 0) {
        actualMonth = 12;
      }
    }
    this.getHistoryMonth(actualMonth, true);
  }

  getHistoryMonth(number, flag) {
    let month;
    switch (number) {
      case 1:
        month = {
          number: 1,
          name: "Janeiro",
          string: "01"
        };
        break;
      case 2:
        month = {
          number: 2,
          name: "Fevereiro",
          string: "02"
        };
        break;
      case 3:
        month = {
          number: 3,
          name: "Março",
          string: "03"
        };
        break;
      case 4:
        month = {
          number: 4,
          name: "Abril",
          string: "04"
        };
        break;
      case 5:
        month = {
          number: 5,
          name: "Maio",
          string: "05"
        };
        break;
      case 6:
        month = {
          number: 6,
          name: "Junho",
          string: "06"
        };
        break;
      case 7:
        month = {
          number: 7,
          name: "Julho",
          string: "07"
        };
        break;
      case 8:
        month = {
          number: 8,
          name: "Agosto",
          string: "08"
        };
        break;
      case 9:
        month = {
          number: 9,
          name: "Setembro",
          string: "09"
        };
        break;
      case 10:
        month = {
          number: 10,
          name: "Outubro",
          string: "10"
        };
        break;
      case 11:
        month = {
          number: 11,
          name: "Novembro",
          string: "11"
        };
        break;
      case 12:
        month = {
          number: 12,
          name: "Dezembro",
          string: "12"
        };
        break;
    }

    let left = this.state.fromHistory.slice(0, 5);
    let after = this.state.fromHistory.slice(7, 19);
    let newFromHistory = `${left}${month.string}${after}`;

    this.setState({ currentMonth: month, fromHistory: newFromHistory }, () => {
      if (flag) {
        this.openItem(null, this.state.currentUserId);
      }
    });
  }

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  toggleModalOrder = () => {
    this.setState(prevState => ({ modalOrder: !prevState.modalOrder }));
  };

  setType = () => {
    const filter = this.props.general.filtered_content;
    let { type } = this.state;

    if (filter) {
      type = filter.type;
    }

    if (type !== 0) {
      this.setState(
        {
          filters: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.filters,
            // eslint-disable-next-line react/no-access-state-in-setstate
            type: this.state.type
          }
        },
        () => {
          this.getLos();
          if (this.props.activity) {
            // eslint-disable-next-line react/no-unused-state
            this.setState({ activity: true });
          }
        }
      );
    } else {
      this.getLos();
    }
  };

  getLos = async () => {
    this.setState({ loading: true });

    const filters = {
      type: this.state.type,
      word: this.state.filters.word,
      segment: this.state.filters.segment && this.state.filters.segment.value,
      discipline:
        this.state.filters.discipline && this.state.filters.discipline.value,
      serie: this.state.filters.serie && this.state.filters.serie.value,
      module:
        !this.state.ability_filter &&
        this.state.filters.module &&
        this.state.filters.module.value,
      ability:
        this.state.ability_filter &&
        this.state.filters.ability &&
        this.state.filters.ability.value,
      content: true
    };

    const losResponse = await axios.post(
      `${URL.api}content/los/listLosFilter`,
      filters,
      {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      }
    );
    this.setState({
      content: losResponse.data.data,
      currentPage: 1,
      loading: false
    });
  };

  fitered = filters => {
    if (this.state.filters.type) {
      filters.type = this.state.filters.type;
    }

    this.setState({ filters }, () => {
      this.getLos();
    });
  };

  getSelected = select => {
    let { selected } = this.state;

    if (selected.length > 0) {
      selected.forEach((item, idx) => {
        if (item.id === select.id) {
          selected.splice(idx, 1);
        }
      });
    }

    selected.push(select);

    this.setState({ selected }, () => {
      let list = [];
      let { selected } = this.state;

      if (this.state.type === "0") {
        selected.forEach(lesson => {
          lesson.slides.forEach(slide => {
            if (slide.checked) {
              slide.father = lesson.id;
              list.push(slide);
            }
          });
        });
      } else {
        list = this.state.contentList.list;
        if (list.length > 0) {
          list.forEach((content, idx) => {
            if (content.id === select.id) {
              list.splice(idx, 1);
            } else {
              list.push(select);
            }
          });
        } else {
          list.push(select);
        }
      }

      this.setState({
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      });
    });
  };

  getOrder = (list, where) => {
    this.setState(
      {
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      },
      () => {
        this.finalize();
      }
    );
  };

  checked = item => {
    this.selectSlide(item);
    let { selectedLessons } = this.state;
    if (selectedLessons.length === 0) {
      selectedLessons.push(item);
    } else {
      selectedLessons.forEach((selected, idx) => {
        if (item.id === selected.id) {
          selectedLessons.splice(idx, 1);
        } else {
          selectedLessons.push(item);
        }
      });
    }
    this.setState(
      {
        selectedLessons
      },
      () => {
        this.finalize();
      }
    );
  };

  finalize = () => {
    // TODO fn para salvar as escolhas
    // this.props.getSelected(this.state.slideList)
  };

  send = () => {
    this.props.getContent(this.state.contentList);
  };

  filter(filters) {
    this.setState({ filters }, () => {
      this.getLos();
    });
  }

  getDate = date => {
    let myDate = `${date}`;
    myDate = myDate.replaceAll("-", ".");
    let newDate = new Date(Math.floor(new Date(myDate).getTime()));
    let todayDay = `00${newDate.getDate()}`.slice(-2);
    let todayMonth = `00${newDate.getMonth() + 1}`.slice(-2);
    let todayYear = newDate.getFullYear();

    let from = `${todayYear}-${todayMonth}-${todayDay}T00:00:00`;
    let to = `${todayYear}-${todayMonth}-${todayDay}T23:59:59`;
    let currentMonth = parseInt(from.slice(5, 7));
    this.setState({ from, to, fromHistory: from }, () => {
      this.getHistoryMonth(currentMonth);
    });
  };

  changeFilter(prop, value) {
    this.setState(
      state => {
        let filter = { ...state.filter };
        filter[prop] = value;

        if (prop === "segment") {
          filter.serie = { value: null, label: "Todas" };
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "serie") {
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "discipline") {
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        }

        // Se o filtro estiver em Habilidades, carregar o abilitiesSegments, senão, carregar o modulesSegments
        let segments = state.ability_filter
          ? [...state.abilitiesSegments]
          : [...state.modulesSegments];

        return { segments, filter, filters: filter };
      },
      () => {
        if (prop !== "word") {
          this.filter(this.state.filter);
        }
      }
    );
  }

  search = () => {
    this.setState({ loading: true });
    if (Object.keys(this.state.infoSelected).length) {
      let paramsObject = {
        group_id: this.state.infoSelected.groupId
          ? this.state.infoSelected.groupId
          : null,
        region_id: this.state.infoSelected.regionId
          ? this.state.infoSelected.regionId
          : null,
        school_id: this.state.infoSelected.schoolId
          ? this.state.infoSelected.schoolId
          : null,
        room_id: this.state.infoSelected.roomId
          ? this.state.infoSelected.roomId
          : null,
        from: this.state.from,
        to: this.state.to
      };
      axios
        .get(`${URL.api}access/user_emotion/listUsers`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          params: paramsObject
        })
        .then(resp => {
          this.setState({ content: resp.data.data, currentPage: 1 }, () => {
            this.setState({ loading: false });
          });
        });
    }
  };

  getInfoSelectors = (groupId, regionId, schoolId, roomId, date) => {
    let obj = {
      groupId,
      regionId,
      schoolId,
      roomId,
      date
    };
    this.setState({ infoSelected: obj });
  };

  openItem = (content, currentUserId) => {
    this.setState({ loadingHistory: true });

    let params = {};
    if (this.state.fromHistory) {
      let month = this.state.fromHistory.slice(5, 7);
      let year = this.state.fromHistory.slice(0, 4);
      let totalDays = new Date(year, month, 0).getDate();
      let newFrom = `${year}-${month}-01T00:00:00`;
      let newTo = `${year}-${month}-${totalDays}T23:59:59`;
      params = {
        from: newFrom,
        to: newTo
      };
    } else {
      let today = new Date();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      let newFrom = `${year}-${month}-01T00:00:00`;
      this.setState({ from: newFrom, fromHistory: newFrom }, () => {
        this.getHistoryMonth(month);
      });
    }

    axios
      .get(
        `${URL.api}access/user_emotion/singleView/${
          currentUserId || content.user_id
        }`,
        {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          params
        }
      )
      .then(resp => {
        this.setState({
          currentContentOpened: resp.data.data,
          showModal: true,
          currentUserId: currentUserId || content.user_id,
          loadingHistory: false
        });
      });
  };

  getArray = data => {
    const header = ["nome", "tipo", "escola", "última emoção"];

    const arr = [header];

    data.forEach((item, index) => {
      arr.push([
        item.name,
        item.role_name,
        item.school_name,
        item.last_emotion_name
      ]);
    });

    return arr;
  };

  render() {
    let img;
    if (this.state.filters.disciplines) {
      let discipline = this.state.filters.disciplines[0];
      img = DefaultDiscipline;
      if (discipline.symbol != null) {
        img = discipline.symbol;
      }
    }

    const filter = {
      word: this.state.filters.word,
      segment:
        this.state.filters.segment &&
        this.state.filters.segment.value &&
        this.state.filters.segment.label,
      discipline:
        this.state.filters.discipline &&
        this.state.filters.discipline.value &&
        this.state.filters.discipline.label,
      serie:
        this.state.filters.serie &&
        this.state.filters.serie.value &&
        this.state.filters.serie.label,
      module:
        this.state.filters.module &&
        this.state.filters.module.value &&
        this.state.filters.module.label,
      ability:
        this.state.filters.ability &&
        this.state.filters.ability.value &&
        this.state.filters.ability.label
    };

    let segments = this.state.segments
      .sort((a, b) => a.order - b.order)
      .map(segment => ({
        value: segment.id,
        label: segment.name,
        series: segment.series
      }));
    let series = [];
    let disciplines = [];
    let modules = [];
    let abilities = [];

    if (this.state.filter.segment?.value) {
      series = segments
        .filter(segment => segment.value === this.state.filter.segment.value)
        .reduce((acc, val) => [...acc, ...val.series], [])
        .sort((a, b) => a.order - b.order)
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    } else {
      series = segments
        .reduce(
          (acc, val) => [
            ...acc,
            ...val.series.map(item => ({ ...item, segment_id: val.value }))
          ],
          []
        )
        .sort(
          (a, b) =>
            a.segment_id * 100 + a.order - (b.segment_id * 100 + b.order)
        )
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    }

    if (this.state.filter.serie?.value) {
      disciplines = series
        .filter(serie => serie.value === this.state.filter.serie.value)
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    } else {
      disciplines = series
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    }

    if (this.state.filter.discipline?.value) {
      modules = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    } else {
      modules = disciplines
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    }

    segments = [
      { value: null, label: "Todos" },
      ...segments.filter(
        (segment, index) =>
          segments.findIndex(item => item.value === segment.value) === index
      )
    ];
    series = [
      { value: null, label: "Todas" },
      ...series.filter(
        (serie, index) =>
          series.findIndex(item => item.value === serie.value) === index
      )
    ];
    disciplines = [
      { value: null, label: "Todos" },
      ...disciplines.filter(
        (discipline, index) =>
          disciplines.findIndex(item => item.value === discipline.value) ===
          index
      )
    ];
    modules = [
      { value: null, label: "Todos" },
      ...modules.filter(
        (module, index) =>
          modules.findIndex(item => item.id === module.id) === index &&
          module.options.length > 0
      )
    ];
    abilities = [
      { value: null, label: "Todos" },
      ...abilities.filter(
        (ability, index) =>
          abilities.findIndex(item => item.id === ability.id) === index &&
          ability.options.length > 0
      )
    ];

    const content = this.state.content;
    let contentLength = 0;
    if (content !== null) {
      contentLength = this.state.content.length;
    }

    return (
      <div className="animated">
        <CCard className="card-overflow">
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div className="d-flex align-items-center mb-1">
                <h4 className="card-title m-0 border-0 mr-1">
                  Listagem de Emoções
                </h4>
              </div>
              <div className="small text-muted">
                Veja o histórico de emoções
              </div>
            </div>
            <div
              className="float-right d-none d-lg-block"
              style={{ width: "30%" }}
            >
              <InputGroup>
                <Input
                  placeholder="Pesquisar"
                  onChange={e => this.changeFilter("word", e.target.value)}
                  value=""
                  type="text"
                  style={{
                    borderRight: 0,
                    outline: 0,
                    borderColor: "#d8dbe0",
                    boxShadow: "none"
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText className="bg-white pl-0">
                    <i
                      className="fa fa-search text-muted content-search-icon"
                      onClick={() => this.filter(this.state.filter)}
                    ></i>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
            <div className="float-right d-block d-lg-none">
              <CButton
                color="primary"
                onClick={() =>
                  this.setState(state => ({
                    filterCollapse: !state.filterCollapse
                  }))
                }
              >
                <i className="fa fa-filter"></i> Filtrar
              </CButton>
            </div>
          </CCardHeader>
          {this.state.content && (
            <div className="d-flex w-100 justify-content-end mt-3 mb-2 pr-3">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLSX(
                    this.getArray(this.state.content),
                    "Listagem de Emoções.xlsx"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLSX
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToXLS(
                    this.getArray(this.state.content),
                    "Listagem de Emoções.xls"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para XLS
              </CButton>
              <span className="mx-2">|</span>
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  arrayToCSV(
                    this.getArray(this.state.content),
                    "Listagem de Emoções.csv"
                  )
                }
              >
                <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
              </CButton>
            </div>
          )}
          <CCardBody className="card-overflow">
            <FilterWithDate
              user={this.props.user}
              getDate={this.getDate}
              getInfoSelectors={this.getInfoSelectors}
              viewOfflineRegister={false}
              buttonAction={this.search}
              isEmotionMode
            />
            <Modal
              isOpen={this.state.showModal}
              toggle={null}
              className={null}
              onOpened={() => {}}
              size="xl"
            >
              <ModalHeader className="d-flex justify-content-end">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.setState({
                      showModal: false,
                      fromHistory: null
                    });
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </ModalHeader>
              {this.state.currentContentOpened && (
                <ModalBody>
                  <div id="emotionContainer">
                    <div id="emotionInfoContainer">
                      <div className="position-relative" id="contentImgEmotion">
                        <i
                          className="fa fa-user text-gray"
                          id="contentIconEmotion"
                        ></i>
                      </div>
                      <div>
                        <h3>{this.state.currentContentOpened.user.name}</h3>
                        {/* <h5>
                          Turma:{" "}
                          {
                            this.state.currentContentOpened.user_role[0]
                              .school_name
                          }
                        </h5> */}
                        <h5>
                          Escola:{" "}
                          {
                            this.state.currentContentOpened.user_role[0]
                              .school_name
                          }
                        </h5>
                      </div>
                      <div id="emotionKeeperContainer">
                        <h4>Contato Responsável:</h4>
                        {this.state.currentContentOpened.user_parent.length >
                        0 ? (
                          <>
                            <h5>
                              {
                                this.state.currentContentOpened.user_parent[0]
                                  .parent.phone
                              }
                            </h5>
                            <h5>
                              {
                                this.state.currentContentOpened.user_parent[0]
                                  .parent.email
                              }
                            </h5>
                          </>
                        ) : (
                          <h5 style={{ textAlign: "center" }}>
                            Sem registro de informações do Responsável
                          </h5>
                        )}
                      </div>
                    </div>
                    <div>
                      <div id="emotionDescriptionContainer">
                        <div id="contentTitleEmotion">
                          Histórico de Sentimentos
                        </div>
                        <div id="emotionMonthContainer">
                          <h5>Ano: {this.state.from.slice(0, 4)} - </h5>
                          <h5>Mês:</h5>
                          {this.state.currentMonth.number > 1 && (
                            <i
                              className="fa fa-caret-left"
                              id="arrowEmotion"
                              onClick={() => {
                                this.increaseOrDecreaseMonth(-1);
                              }}
                            ></i>
                          )}
                          <h3>{this.state.currentMonth.name}</h3>
                          {this.state.currentMonth.number < 12 && (
                            <i
                              className="fa fa-caret-right"
                              id="arrowEmotion"
                              onClick={() => {
                                this.increaseOrDecreaseMonth(1);
                              }}
                            ></i>
                          )}
                        </div>
                      </div>
                      <div id="emotionContentMonth" style={{ minHeight: 0 }}>
                        {this.state.loadingHistory ? (
                          <Loading />
                        ) : this.state.currentContentOpened.user_emotion
                            .length ? (
                          <div id="emotionHistoryContainer">
                            {this.state.currentContentOpened.user_emotion
                              .length &&
                              this.state.currentContentOpened.user_emotion.map(
                                item => (
                                  <div id="emotionHistoryCard">
                                    <h5>
                                      {item.created_at_with_timezone.slice(
                                        8,
                                        10
                                      )}
                                    </h5>
                                    <img
                                      src={URL.img + item.emotion_url}
                                      className="rounded-circle"
                                      width="91px"
                                      height="91px"
                                    />
                                    <h5 className="mt-1">
                                      {item.emotion_name}
                                    </h5>
                                  </div>
                                )
                              )}
                          </div>
                        ) : (
                          <div className="text-muted p-4 d-flex justify-content-center">
                            Nenhum registro de Emoção encontrado
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </ModalBody>
              )}
            </Modal>
            <div className="cardContent" style={{ minHeight: 0 }}>
              {this.state.loading ? (
                <Loading />
              ) : content === null ? (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Selecione os filtros acima
                </div>
              ) : content.length > 0 ? (
                <div>
                  <div className="contentArea row">
                    {content.map((content, idc) => (
                      <CCol xs="12" md="6" lg="4" xl="3" key={`type-${idc}`}>
                        <div onClick={() => this.openItem(content)}>
                          <EmotionsContentItem data={content} />
                        </div>
                      </CCol>
                    ))}
                  </div>
                  <hr className="my-4" />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div>
                      <span>Total de Conteúdos: {contentLength}</span>
                    </div>
                    <CPagination
                      className="m-0"
                      addListClass="m-0"
                      activePage={this.state.currentPage}
                      pages={
                        Math.ceil(content.length / this.state.maxItems) || 1
                      }
                      onActivePageChange={page =>
                        this.setState({ currentPage: page })
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Nenhum conteúdo encontrado
                </div>
              )}
            </div>
          </CCardBody>
        </CCard>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EmotionsContent);
